import { Spinner } from "react-bootstrap";
import "./style.scss";
import { useEffect, useRef, useState } from "react";
import ConfirmModal from "./../../../pages/profile/ConfirmModal/index";
import { t } from "i18next";
import DBConfirmModal from "./../DBConfirmModal/index";
export default function DBUpload({
    type,
    caption,
    onClick,
    disabled,
    className,
    outlined,
    onChange,
    accept,
    maxSize,
}) {
    const [localOnChange, setLocalOnChange] = useState();
    const [reset, setReset] = useState(false);
    const [sizeErrorModalShow, setSizeErrorModalShow] = useState(false);
    const [typeErrorModalShow, setTypeErrorModalShow] = useState(false);
    const fileInput = useRef();

    useEffect(() => {
        if (localOnChange) {
            const validTypes = accept
                .split(",")
                .map((item) =>
                    item === ".xlsx"
                        ? ".vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        : item === ".zip"
                        ? ".x-zip-compressed"
                        : item
                );
            const fileType =
                "." + localOnChange.target.files?.[0].type.split("/")[1];
            console.log(validTypes, fileType);
            if (!validTypes.includes(fileType)) {
                setTypeErrorModalShow(true);
            } else if (
                localOnChange.target.files[0].size > maxSize &&
                maxSize
            ) {
                setSizeErrorModalShow(true);
            } else {
                onChange(localOnChange);
                setReset(!reset);
            }
        }
    }, [localOnChange]);
    return (
        <>
            <DBConfirmModal
                show={sizeErrorModalShow}
                title={t("file.upload.error.title")}
                description={t("file.upload.error.desc")}
                btnTitle={t("file.upload.confirm.btn")}
                onConfirm={() => setSizeErrorModalShow(false)}
                hideCancelBtn
                minWidth={400}
            />
            <DBConfirmModal
                show={typeErrorModalShow}
                title={t("file.upload.error.title")}
                description={t("file.upload.error.desc.type")}
                btnTitle={t("file.upload.confirm.btn")}
                onConfirm={() => setTypeErrorModalShow(false)}
                hideCancelBtn
                minWidth={400}
            />
            <label
                className={`db-button ${type || "primary"} ${className} ${
                    outlined ? "outlined" : ""
                } ${disabled ? "disabled" : ""}`}
                onClick={onClick}
            >
                {caption} ({Math.round((maxSize / (1024 * 1024)) * 100) / 100}{" "}
                {t("megabytes")}
                )
                <input
                    ref={fileInput}
                    key={reset}
                    type="file"
                    accept={accept}
                    onChange={setLocalOnChange}
                    disabled={disabled}
                    style={{ display: "none" }}
                />
            </label>
        </>
    );
}
